import axios from 'axios';

const client = axios.create({
  baseURL: '/api/v1/',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      return Promise.reject({
        status: error.response.status,
        message: error.response.data?.error || error.response.data?.message || 'An error occurred',
        data: error.response.data,
      });
    }
    return Promise.reject({ status: 0, message: 'Network error.' });
  }
);

export const api = {
  // Analysis
  submitEmail: (data) => {
    if (data instanceof FormData) {
      return client.post('analyze/', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return client.post('analyze/', data);
  },
  getAnalysis: (id) => client.get(`analyze/${id}/`),
  getAnalysisStatus: (id) => client.get(`analyze/${id}/status/`),
  lookupAnalysis: (params) => client.get('analyze/lookup/', { params }),

  // Stats & history
  getStats: () => client.get('stats/'),
  getHistory: (params = {}) => client.get('history/', { params }),

  // Community reports
  submitReport: (data) => client.post('reports/', data),
  getReports: (senderDomain) => client.get('reports/list/', { params: { sender_domain: senderDomain } }),
  upvoteReport: (reportId) => client.post(`reports/${reportId}/upvote/`),
  replyToReport: (reportId, data) => client.post(`reports/${reportId}/reply/`, data),
  quickVote: (senderDomain, vote) => client.post('quick-vote/', { sender_domain: senderDomain, vote }),

  // Removal request
  requestRemoval: (analysisId, data) => client.post(`removal-request/${analysisId}/`, data),

  // Community profiles
  communityRegister: (data) => client.post('community/register/', data),
  communityLogin: (data) => client.post('community/login/', data),
  communityLeaderboard: (params = {}) => client.get('community/leaderboard/', { params }),
  communityStats: () => client.get('community/stats/'),
  communityProfile: (pseudo) => client.get(`community/profile/${pseudo}/`),
};

export default client;
